import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable no-console */
import { useLocalStorageState } from "@sundae/react-hooks";
import deepmerge from "deepmerge";
import hasIn from "lodash/hasIn.js";
import omitBy from "lodash/omitBy.js";
import { createContext, useCallback, useContext, useMemo, useReducer, } from "react";
import { useAppContext } from "../AppContext/context.js";
import { ProfileAppReducer } from "./reducer.js";
import { ECardanoExplorer, EProfileAppActions, } from "./types.js";
export const defaultPersistentState = {
    activeLanguage: "en",
    cardanoExplorer: ECardanoExplorer.cexplorer,
    errorReportingEnabled: false,
};
const ProfileAppContext = createContext({
    state: defaultPersistentState,
    dispatch: () => { },
});
export const ProfileAppContextProvider = ({ children, }) => {
    const { state: { clientSettings: { clientNamespace }, }, } = useAppContext();
    const [savedState, saveState, remove] = useLocalStorageState(`${clientNamespace}-LOCAL_STORAGE`, defaultPersistentState);
    const persistentReducer = useCallback((state, action) => {
        const newState = ProfileAppReducer(state, action);
        if (action.type === EProfileAppActions.LOGOUT) {
            remove();
        }
        else {
            saveState(newState);
        }
        return newState;
    }, [saveState, remove]);
    const hydratedState = useMemo(() => {
        const hydrated = deepmerge(defaultPersistentState, omitBy(savedState, (_value, key) => {
            if (!hasIn(defaultPersistentState, key)) {
                return true;
            }
            return false;
        }));
        return {
            ...defaultPersistentState,
            ...hydrated,
        };
    }, [savedState]);
    const [state, dispatch] = useReducer(persistentReducer, hydratedState);
    return (_jsx(ProfileAppContext.Provider, { value: { state, dispatch }, children: children }));
};
// Utility hook.
export const useProfileAppContext = () => useContext(ProfileAppContext);
//# sourceMappingURL=context.js.map